import { render, staticRenderFns } from "./AttestsForm.vue?vue&type=template&id=3165628c"
import script from "./AttestsForm.vue?vue&type=script&lang=js"
export * from "./AttestsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports